<template>
  <v-fade-transition mode="out-in">
    <button :key="$vuetify.theme.dark" class="appbar-pill" :class="$vuetify.theme.dark ? 'pill-amber' : 'pill-indigo'" @click="handleDark" :title="$vuetify.theme.dark ? 'Light mode' : 'Dark mode'">
      <v-icon size="18" :color="$vuetify.theme.dark ? '#FFB300' : '#6366F1'">
        {{ $vuetify.theme.dark ? icons.mdiWeatherSunny : icons.mdiWeatherNight }}
      </v-icon>
    </button>
  </v-fade-transition>
</template>

<script>
import { mdiWeatherNight, mdiWeatherSunny } from '@mdi/js';

export default {
  setup() {
    return {
      icons: {
        mdiWeatherNight,
        mdiWeatherSunny,
      },
    };
  },
  data() {
    return {
      darkmode: false,
    };
  },
  watch: {
    darkmode(oldval, newval) {
      this.handledarkmode();
    },
  },
  created() {
    if (process.browser) {
      if (localStorage.getItem('DarkMode')) {
        const cookieValue = localStorage.getItem('DarkMode') === 'true';
        this.darkmode = cookieValue;
      } else {
        this.handledarkmode();
      }
    }
  },
  methods: {
    handleDark() {
      if (this.$vuetify.theme.dark) {
        this.$vuetify.theme.dark = false;
        localStorage.setItem('DarkMode', false);
      } else {
        this.$vuetify.theme.dark = true;
        localStorage.setItem('DarkMode', true);
      }
    },
    handledarkmode() {
      if (process.browser) {
        if (this.darkmode === true) {
          this.$vuetify.theme.dark = true;
          localStorage.setItem('DarkMode', true);
        } else if (this.darkmode === false) {
          this.$vuetify.theme.dark = false;
          localStorage.setItem('DarkMode', false);
        }
      }
    },
  },
};
</script>

<style>
.appbar-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: rgba(0,0,0,0.06);
  border: none;
  cursor: pointer;
  transition: background 0.18s, transform 0.15s;
  margin-left: 6px;
}
.appbar-pill:hover {
  background: rgba(0,0,0,0.12);
  transform: translateY(-1px);
}
.theme--dark .appbar-pill {
  background: rgba(255,255,255,0.1);
}
.theme--dark .appbar-pill:hover {
  background: rgba(255,255,255,0.18);
}
</style>
